import React from 'react';
import cn from 'classnames';
import './BrandBillingWorklist.scss';

import { getBrandBillingQualities, formatMrr } from '../../helpers/brand_billing_helpers';

const BrandBillingWorklist = props => {
  const { worklist } = props;

  if (worklist === false) return <div className='brand-billing-quiet'>Couldn’t load the worklist.</div>;
  if (!worklist) return <div className='brand-billing-quiet'>Checking…</div>;
  if (!worklist.brands.length) return <div className='brand-billing-quiet'>Nothing looks wrong.</div>;

  return (
    <div className='brand-billing-worklist'>
      <div className='brand-billing-group-head'>
        <span className='brand-billing-count urgent'>{worklist.total}</span>
        <span className='brand-billing-group-label'>brands billed inconsistently</span>
      </div>

      {worklist.brands.map(brand => (
        <div className='brand-billing-row' key={brand.Brand_id} onClick={() => props.onOpen(brand.Brand_id, brand.name)}>
          <div className='brand-billing-row-brand'>
            <span className='brand-billing-row-name'>{brand.name}</span>
            <span className='brand-billing-row-domain'>{brand.domain}</span>
          </div>
          <div className='brand-billing-row-qualities'>
            {getBrandBillingQualities(brand).map(quality => (
              <span className={cn('brand-billing-quality', quality.tone)} key={quality.label}>
                {quality.label}
              </span>
            ))}
          </div>
          <span className='brand-billing-row-mrr'>{formatMrr(brand.mrr)}</span>
        </div>
      ))}

      {worklist.total > worklist.brands.length && (
        <div className='brand-billing-quiet'>
          Showing the {worklist.brands.length} largest of {worklist.total}.
        </div>
      )}
    </div>
  );
};

export default BrandBillingWorklist;
